"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    alignToAnchor: {
        type: Boolean,
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    appendTo: {
        type: String,
        default: undefined
    },
    closeOnClick: {
        type: Boolean,
        default: undefined
    },
    copyAnchorStyles: {
        type: Boolean,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dataContentField: {
        type: String,
        default: undefined
    },
    direction: {
        type: String,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    hoverDelay: {
        type: Number,
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    popupCollision: {
        type: String,
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },
    showOn: {
        type: String,
        default: undefined
    },
    target: {
        type: String,
        default: undefined
    },

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
};